import TextSkeleton from '@components/V3/Text/TextSkeleton'

export default function LoyaltySkeleton() {
  return (
    <div className="rounded-xl shadow-lg p-4 space-y-4 my-5">
      <div className="flex flex-row items-center justify-between">
        <div className="rounded-lg bg-gray-200 h-14 w-24 animate-pulse" />
        <span className="">
          <TextSkeleton type="body" className="w-20" />
          <TextSkeleton type="body" className="w-20" />
        </span>
      </div>
      <div className="flex flex-col items-center justify-center">
        <TextSkeleton type="body" className="w-3/5" />
        <TextSkeleton type="body" className="w-3/5" />
      </div>
      <div className="flex flex-row items-center justify-around">
        <div className="rounded-lg bg-gray-200 h-40 w-40 animate-pulse hidden sm:block" />
        <span className="w-full sm:w-36">
          <TextSkeleton type="body" />
          <TextSkeleton type="body" />
          <TextSkeleton type="body" />
          <TextSkeleton type="body" className="hidden sm:block" />
          <TextSkeleton type="body" className="hidden sm:block" />
          <TextSkeleton type="body" className="hidden sm:block" />
        </span>
      </div>
    </div>
  )
}
